<template>
  <CContainer class="pt-5 mb-5" fluid>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">APHT Payment</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item to="/invoice-apht">
            <CIcon name="cil-credit-card" />
            Need Approval
          </b-breadcrumb-item>
          <b-breadcrumb-item active>Detail</b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CRow class="mx-2">
      <CCol class="col-12 col-md-6 p-1">
        <CCard class="custom-form-card custom-card">
          <CCardBody>
            <CRow>
              <CCol class="col-12">
                <h5 class="custom-header-display">Data FIFApps</h5>
              </CCol>
            </CRow>
            <CRow>
              <CCol class="pt-2 custom-detail-list">
                <CRow v-if="isLoadingAPHT">
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                </CRow>
                <CRow v-else>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                    <p>ID Vendor</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                    <p>: {{ $helper.showData(details.vendorId, "string") }}</p>
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                    <p>Nama Vendor</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                    <p>: {{ $helper.showData(details.vendorName, "string") }}</p>
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                    <p>Bank Vendor</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                    <p>: {{ $helper.showData(details.vendorBank, "string") }}</p>
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                    <p>Akun Bank Vendor</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                    <p>: {{ $helper.showData(details.vendorBankAccount, "string") }}</p>
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                    <p>Nama Akun Bank</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                    <p>: {{ $helper.showData(details.vendorAccountName, "string") }}</p>
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                    <p>Status Vendor</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                    <p>: {{ $helper.showData(details.vendorStatus, "string") }}</p>
                  </CCol>
              </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
        <CCard class="custom-form-card custom-card mt-2">
          <CCardBody>
            <CRow>
              <CCol class="col-12">
                <h5 class="custom-header-display">Data Kolateral</h5>
              </CCol>
            </CRow>
            <CRow>
              <CCol class="pt-2 custom-detail-list">
                <CRow v-if="isLoadingAPHT">
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                </CRow>
                <CRow v-else>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>No. Sertifikat Tanah</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.nomorSertifikatTanah, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Nama Sertifikat Tanah</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.namaSertifikatTanah, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Status Hak</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.statusHak, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Nilai Appraisal</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: Rp {{ $helper.showData(details.nilaiAppraisal, "number") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>No. Sertifikat HT</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.certificateNo, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Tanggal Sertifikat HT</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.certificateDate, "shortDate") }}</p>
                  </CCol>
              </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol class="col-12 col-md-6 p-1">
        <CCard class="custom-form-card custom-card">
          <CCardBody>
            <CRow>
              <CCol class="col-12">
                <h5 class="custom-header-display">Data FIMS</h5>
              </CCol>
              <CCol class="col-12 pt-2 custom-detail-list">
                <CRow v-if="isLoadingAPHT">
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                </CRow>
                <CRow v-else>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Tipe Kontrak</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: APHT</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>No. Kontrak</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.contractNo, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>No. Memo</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.invoiceMemoNo, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>No. Appl</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.applNo, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Nama Office</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.officeName, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Status</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.memoStatusDisplay, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Tanggal Pembuatan</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.createdAt, "shortDate") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Biaya Notaris</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: Rp {{ $helper.showData(details.notaryFee, "number") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Biaya Materai</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: Rp {{ $helper.showData(details.materaiFee, "number") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Biaya PNBP</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: Rp {{ $helper.showData(details.pnbpFee, "number") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Pokok Pembiayaan</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: Rp {{ $helper.showData(details.pokokPembiayaan, "number") }}</p>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow class="mb-2 mx-2">
      <CCol class="col-12 p-1">
        <CCard class="custom-form-card custom-card">
          <CCardBody>
            <CRow>
              <CCol class="col-12">
                <h5 class="custom-header-display">Notes</h5>
              </CCol>
              <CCol class="col-7 col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-6" v-if="isLoadingAPHT">
                <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
              </CCol>
              <CCol class="col-7 col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-6" v-else>
                {{ $helper.showData(details.notes, "string") }}
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow class="mb-2 mx-2">
      <CCol class="col-12 p-1">
        <CCard class="custom-form-card custom-card">
          <CCardBody>
            <CRow>
              <CCol class="col-12">
                <h5 class="custom-header-display">Approval Berjenjang</h5>
              </CCol>
            </CRow>
            <CRow>
              <CCol class="col-12 pt-2 custom-detail-list">
                <template v-if="isLoadingAPHT">
                  <CRow v-for="index in 5" :key="index">
                    <CCol class="col-7 col-xs-7 col-sm-6 col-md-7 col-lg-7 col-xl-6 mb-1">
                      <CRow>
                        <CCol class="col-12 col-xs-12 col-sm-12 col-md-8 col-lg-12 col-xl-8">
                          <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                        </CCol>
                        <CCol class="col-12 col-xs-12 col-sm-12 col-md-4 col-lg-12 col-xl-4">
                          <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                        </CCol>
                      </CRow>
                    </CCol>
                  </CRow>
                </template>
                <template v-else>
                  <CRow v-for="(item, index) in details.approvalBerjenjang" :key="'approval-' + index">
                    <CCol class="col-4">
                      <strong v-if="item.level === details.approvalLevel">Level {{ item.level }}</strong>
                      <template v-else>Level {{ item.level }}</template>
                    </CCol>
                    <CCol class="col-8">
                      <strong v-if="item.level === details.approvalLevel">
                        : 
                        <span v-for="(value, index2) in item.values" :key="'approval-value-' + index2">
                          {{ index2 != 0 ? ', ' : '' }}{{ value.text }}
                        </span>
                      </strong>
                      <template v-else>
                        : 
                        <span v-for="(value, index2) in item.values" :key="'approval-value-' + index2">
                          {{ index2 != 0 ? ', ' : '' }}{{ value.text }}
                        </span>
                      </template>
                    </CCol>
                  </CRow>
                </template>
              </CCol>
            </CRow>
            <CRow class="mt-4 mb-0 pb-0" v-if="details.memoStatus == 'RJ' || details.memoStatus == 'RV'">
              <CCol>
                <b-alert show variant="warning" v-if="details.memoStatus == 'RV'">
                  <span v-if="!$helper.isEmpty(details.reviseRequestByName)">({{ details.reviseRequestByName }}) </span>
                  <span v-if="!$helper.isEmpty(details.reviseNotes)">{{ details.reviseNotes }}</span>
                </b-alert>
                <b-alert show variant="danger" v-if="details.memoStatus == 'RJ'">
                  <span v-if="!$helper.isEmpty(details.rejectedByName)">({{ details.rejectedByName }}) </span>
                  <span v-if="!$helper.isEmpty(details.rejectNotes)">{{ details.rejectNotes }}</span>
                </b-alert>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <template v-if="$helper.isRole($availRoles['Cabang'])">
        <template v-if="isLoadingAPHT">
          <CCol class="col-3 offset-3 mt-4">
            <Skeleton type="rect" :width="'100%'" :height="'1.93rem'" animation="fade" />
          </CCol>
          <CCol class="col-3 mt-4">
            <Skeleton type="rect" :width="'100%'" :height="'1.93rem'" animation="fade" />
          </CCol>
          <CCol class="col-3 mt-4">
            <Skeleton type="rect" :width="'100%'" :height="'1.93rem'" animation="fade" />
          </CCol>
        </template>
        <CCol class="col-12 mt-4" v-else-if="details.memoStatus == 'OA'">
          <b-btn variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:9rem" :disabled="isSubmitting.rejectAPHT" @click="rejectModalData.isShowing = true">
            <b-spinner small v-if="isSubmitting.updateAPHT" />
            <span v-else>Reject APHT</span>
          </b-btn>
          <b-btn variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:9rem" :disabled="isSubmitting.requestRevision" @click="requestRevisionModalData.isShowing = true">
            <b-spinner small v-if="isSubmitting.requestRevision" />
            <span v-else>Request Revision</span>
          </b-btn>
          <b-btn variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:9rem" :disabled="isSubmitting.approveAPHT" @click="approveModalData.isShowing = true">
            <b-spinner small v-if="isSubmitting.approveAPHT" />
            <span v-else>Approve APHT</span>
          </b-btn>
        </CCol>
      </template>
    </CRow>

    <CModal :closeOnBackdrop="false" :show.sync="approveModalData.isShowing" :centered="true">
      <div slot="header"><h5>Konfirmasi Persetujuan Memo Invoice</h5></div>
      <div class="body">
        <CRow class="mb-2">
          <CCol>
            Apakah Anda yakin ingin menyetujui pengajuan memo invoice ini?
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Invoice Memo No.
          </CCol>
          <CCol md="8" sm="7">
            : {{ $route.params.invoiceMemoNo }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Pokok Pembiayaan
          </CCol>
          <CCol md="8" sm="7">
            : Rp{{ $helper.showData(details.pokokPembiayaan, "number") }}
          </CCol>
        </CRow>
      </div>
      <div slot="footer">
        <CButton color="secondary" @click="approveModalData.isShowing = false">Batal</CButton>
        <CButton class="ml-2" color="primary" @click="confirmApproveAPHT" :disabled="approveModalData.isLoading">
          <b-spinner small type="grow" v-if="approveModalData.isLoading" /> 
          {{ approveModalData.isLoading ? 'Sedang diproses...' : 'Ya' }}
        </CButton>
      </div>
    </CModal>

    <CModal :closeOnBackdrop="false" :show.sync="rejectModalData.isShowing" :centered="true">
      <div slot="header"><h5>Konfirmasi Penolakan Memo Invoice</h5></div>
      <div class="body">
        <CRow class="mb-2">
          <CCol>
            Apakah Anda yakin ingin menolak pengajuan memo invoice ini?
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <b-form-group
              invalid-feedback="This input is required."
              label="Invoice Memo No.:"
              label-for="modal-reject-invoiceMemoNo"
            >
              <b-form-input
                v-model="$route.params.invoiceMemoNo"
                id="modal-reject-invoiceMemoNo"
                disabled
              ></b-form-input>
            </b-form-group>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <b-form-group
              invalid-feedback="This input is required."
              label="Reject Note:"
              label-for="modal-reject-note"
              :state="rejectModalData.rejectNote.isValid"
            >
              <b-form-textarea
                v-model="rejectModalData.rejectNote.value"
                :state="rejectModalData.rejectNote.isValid"
                placeholder="Reject Note"
                id="modal-reject-note"
                rows="4"
                max-rows="4"
                maxlength="500"
              ></b-form-textarea>
            </b-form-group>
          </CCol>
        </CRow>
      </div>
      <div slot="footer">
        <CButton color="secondary" @click="rejectModalData.isShowing = false">Batal</CButton>
        <CButton class="ml-2" color="primary" @click="confirmRejectAPHT" :disabled="rejectModalData.isLoading">
          <b-spinner small type="grow" v-if="rejectModalData.isLoading" /> 
          {{ rejectModalData.isLoading ? 'Sedang diproses...' : 'Ya' }}
        </CButton>
      </div>
    </CModal>

    <CModal :closeOnBackdrop="false" :show.sync="requestRevisionModalData.isShowing" :centered="true">
      <div slot="header"><h5>Konfirmasi Revisi Memo Invoice</h5></div>
      <div class="body">
        <CRow class="mb-2">
          <CCol>
            Apakah Anda yakin ingin merevisi pengajuan memo invoice ini?
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <b-form-group
              invalid-feedback="This input is required."
              label="Invoice Memo No.:"
              label-for="modal-revise-invoiceMemoNo"
            >
              <b-form-input
                v-model="$route.params.invoiceMemoNo"
                id="modal-revise-invoiceMemoNo"
                disabled
              ></b-form-input>
            </b-form-group>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <b-form-group
              invalid-feedback="This input is required."
              label="Revise Note:"
              label-for="modal-revise-note"
              :state="requestRevisionModalData.reviseNote.isValid"
            >
              <b-form-textarea
                v-model="requestRevisionModalData.reviseNote.value"
                :state="requestRevisionModalData.reviseNote.isValid"
                placeholder="Revise Note"
                id="modal-revise-note"
                rows="4"
                max-rows="4"
                maxlength="500"
              ></b-form-textarea>
            </b-form-group>
          </CCol>
        </CRow>
      </div>
      <div slot="footer">
        <CButton color="secondary" @click="requestRevisionModalData.isShowing = false">Batal</CButton>
        <CButton class="ml-2" color="primary" @click="confirmReviseAPHT" :disabled="requestRevisionModalData.isLoading">
          <b-spinner small type="grow" v-if="requestRevisionModalData.isLoading" /> 
          {{ requestRevisionModalData.isLoading ? 'Sedang diproses...' : 'Ya' }}
        </CButton>
      </div>
    </CModal>
  </CContainer>
</template>


<script>
export default {
  name: 'InvoiceDetail',
  data() {
    return {

      approveModalData: {
        isShowing: false,
        isLoading: false,
      },

      requestRevisionModalData: {
        isShowing: false,
        isLoading: false,
        reviseNote: {
          value: '',
          isValid: null,
          isRequired: false,
        }
      },

      rejectModalData: {
        isShowing: false,
        isLoading: false,
        rejectNote: {
          value: '',
          isValid: null,
          isRequired: false,
        }
      },

      isLoadingAPHT: true,

      isSubmitting: {
        rejectAPHT: false,
        requestRevision: false,
        approveAPHT: false,
      },

      details: {
        // documentNotes: '',
        // documentStatus: '',
        // approvalLevel: -1,
        // contractType: '',
        // contractNo: '',
        // officeCode: '',
        // officeName: '',
        // contractStatus: '',
        // contractDate: '',
        // notaryName: '',
        // notes: '',
        // assignmentDate: '',
        // customerName: '',
        // customerAddress: '',
        // customerDob: '',
        // customerKtp: '',
        // bussUnit: '',
        // mouType: '',
        // aktaAvailable: false,
        // certificateAvailable: false,
        // memoStatus: null,
        // rejectNotes: null,
        // reviseNotes: null,
        // creator: false,
        // listDocument: []
      },
    }
  },
  methods: {

    confirmApproveAPHT() {
      this.approveModalData.isLoading = true

      if(this.$helper.isRole(this.$availRoles['Cabang'])){
        let processUrl = "/aphtPayment/approveMemo";
        let data = new FormData();
        data.set('invoiceMemoNo', this.$route.params.invoiceMemoNo);
        data.set('pokokPembiayaan', this.details.pokokPembiayaan);
        this.$axios.post(processUrl, data).then((response) => {
          if (response.status === 200){
            this.$helper.toastSuccess(this.$root, "Approve Memo Berhasil! " + (response.data.reason ? response.data.reason : ""))
            this.$router.push('/invoice-apht')
          } else {
            this.$helper.toastError(this, "Approve Memo Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Approve Memo Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Approve Memo Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.approveModalData.isLoading = false
        })
      }
    },

    confirmRejectAPHT() {
      let isFormValid = true
      
      if (this.$helper.isEmpty(this.rejectModalData.rejectNote.value)) {
        this.rejectModalData.rejectNote.isValid = false
        isFormValid = false
      } else{
        this.rejectModalData.rejectNote.isValid = null
      }

      if(this.$helper.isRole(this.$availRoles['Cabang']) && isFormValid){
        this.rejectModalData.isLoading = true

        let processUrl = "/aphtPayment/rejectMemo";
        let data = new FormData();
        data.set('invoiceMemoNo', this.$route.params.invoiceMemoNo);
        data.set('rejectNotes', this.rejectModalData.rejectNote.value);
        this.$axios.post(processUrl, data).then((response) => {
          if (response.status === 200){
            this.$helper.toastSuccess(this.$root, "Reject Memo Berhasil! " + (response.data.reason ? response.data.reason : ""))
            this.$router.push('/invoice-apht')
          } else {
            this.$helper.toastError(this, "Reject Memo Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Reject Memo Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Reject Memo Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.rejectModalData.isLoading = false
        })
      }
    },

    confirmReviseAPHT() {
      let isFormValid = true
      
      if (this.$helper.isEmpty(this.requestRevisionModalData.reviseNote.value)) {
        this.requestRevisionModalData.reviseNote.isValid = false
        isFormValid = false
      } else{
        this.requestRevisionModalData.reviseNote.isValid = null
      }

      if(isFormValid){
        this.requestRevisionModalData.isLoading = true

        let processUrl = "/aphtPayment/reviseMemo";
        let data = new FormData();
        data.set('invoiceMemoNo', this.$route.params.invoiceMemoNo);
        data.set('reviseNotes', this.requestRevisionModalData.reviseNote.value);
        this.$axios.post(processUrl, data).then((response) => {
          if (response.status === 200){
            this.$helper.toastSuccess(this.$root, "Request Revise Memo Berhasil! " + (response.data.reason ? response.data.reason : ""))
            this.$router.push('/invoice-apht')
          } else {
            this.$helper.toastError(this, "Request Revise Memo Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Request Revise Memo Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Request Revise Memo Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.requestRevisionModalData.isLoading = false
        })
      }
    },

    reorganizeItemLevels() {
      let index = 1
      this.updateApprovalModalData.table.items.forEach(item => {
        item.level = index++
      })
    },

    onRowHover(idx){
      this.details.listDocument[idx].isHovered = true
    },
    onRowLeave(idx){
      this.details.listDocument[idx].isHovered = false
    },
    getAPHT(){
      this.isLoadingAPHT = true
      let getUrl = "/aphtPayment/getMemoDetail"
      let params = {}
      params['invoiceMemoNo'] = this.$route.params.invoiceMemoNo
      this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
            this.details = response.data.data
            this.details.approvalBerjenjang = JSON.parse(this.details.approvers)
            if(this.details.memoStatus == "OA"){
              this.details.memoStatusDisplay = "ON APPROVAL"
            }
            else if(this.details.memoStatus == "AP"){
              this.details.memoStatusDisplay = "APPROVED"
            }
            else if(this.details.memoStatus == "RJ"){
              this.details.memoStatusDisplay = "REJECTED"
            }
            else if(this.details.memoStatus == "RV"){
              this.details.memoStatusDisplay = "NEED REVISE"
            }
            else{
              this.details.memoStatusDisplay = "-"
            }
            // console.log(response.data)
        //   this.details.officeName = response.data.data.officeName
        //   this.details.memoStatus = response.data.data.memoStatus
        //   this.details.approvalLevel = response.data.data.approvalLevel
        //   switch (response.data.data.memoStatus) {
        //     case 'OA':
        //       this.details.memoStatusName = 'On Approval'
        //       break
        //     case 'AP':
        //       this.details.memoStatusName = 'Approved'
        //       break
        //     case 'RJ':
        //       this.details.memoStatusName = 'Rejected'
        //       this.details.rejectNotes = response.data.data.rejectNotes
        //       break
        //     case 'RV':
        //       this.details.memoStatusName = 'Need Revise'
        //       this.details.reviseNotes = response.data.data.reviseNotes
        //       break
        //   }
        //   this.details.createdAt = response.data.data.createdAt
        //   this.details.objectPrice = response.data.data.objectPrice
        //   this.details.notaryFee = response.data.data.notaryFee
        //   this.details.notes = response.data.data.notes
        //   this.details.applNo = response.data.data.applNo
        //   this.details.contractNo = response.data.data.contractNo
        //   this.details.customerName = response.data.data.customerName
        //   this.details.nilaiPenjaminan = response.data.data.nilaiPenjaminan
        //   this.details.pokokPembiayaan = response.data.data.pokokPembiayaan
        //   this.details.creator = response.data.data.creator
        //   // this.details.customerName = response.data.data.customerName
        //   // this.details.customerAddress = response.data.data.customerAddress
        //   // this.details.customerDob = response.data.data.customerDob
        //   // this.details.customerKtp = response.data.data.customerKtp
        //   // this.details.bussUnit = response.data.data.bussUnit
        //   // this.details.mouType = response.data.data.mouType
        //   // this.details.aktaAvailable = response.data.data.aktaAvailable
        //   // this.details.certificateAvailable = response.data.data.certificateAvailable
        //   this.details.listDocument = response.data.data.listDocument.map(item => {
        //     let formattedExtension = item.extension.map(ext => {
        //       return "." + ext
        //     })
        //     let acceptedExtension = formattedExtension.join(", ")
        //     return {
        //       "id": item.id,
        //       "name": item.name,
        //       "repoGroup": item.repoGroup,
        //       "repoCategory": item.repoCategory,
        //       "repositoryId": item.repositoryId,
        //       "extension": item.extension,
        //       "extensionFile": item.extensionFile,
        //       "acceptedExtension": acceptedExtension,
        //       "fileUpload": null,
        //       "isTransferring": false,
        //       "isHovered": false
        //     }
        //   })
        }
        else{
          this.$helper.toastError(this, "Load Detail Memo Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Detail Memo Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Load Detail Memo Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoadingAPHT = false
      })
    },
    // async getAPHTApproval(invoiceMemoNo){
    //   this.isLoadingApproval = true
    //   let getUrl = "/apht/getApprovers"
    //   params['invoiceMemoNo'] = invoiceMemoNo
    //   await this.$axios.get(getUrl).then(response => {
    //     if(response.status == 200){
    //       this.approval = response.data.data
    //     }
    //     else{
    //       this.$helper.toastError(this, "Load Approval Berjenjang APHT Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
    //     }
    //   })
    //   .catch(error => {
    //     if(!this.$helper.isEmpty(error.response)){
    //       this.$helper.toastError(this, "Load Approval Berjenjang APHT Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
    //     }
    //     else{
    //       this.$helper.toastError(this, "Load Approval Berjenjang APHT Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
    //     }
    //   })
    //   .finally(() => {
    //     this.isLoadingApproval = false
    //   })
    // },
    showUploadModal(idx) {
      this.$refs['document-upload-' + idx][0].$el.childNodes[0].click()
    },
    uploadDocument(file, idx){
      let isFormValid = true
      let payload = new FormData()
      if(file.size > this.$uploadLimit){
        this.$helper.toastError(this, "Mohon upload dokumen dengan size lebih rendah dari 1 MB")
        isFormValid = false
      }
      // submit form data if every field is valid
      if(isFormValid){
        let postUrl = '/contractDocument/upload'
        let allowedExtension = this.details.listDocument[idx].extension
        let fileNameSplit = file.name.split(".")
        let fileExt = fileNameSplit[fileNameSplit.length-1]
        payload.append("repoCategory", this.details.listDocument[idx].repoCategory)
        payload.append("repoGroup", this.details.listDocument[idx].repoGroup)
        payload.append("contractId", this.$route.params.fiduciaId)
        payload.append("allowedExtension", JSON.stringify(allowedExtension))
        payload.append("extension", fileExt)
        payload.append("file", file)
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['Cabang'])){
          this.details.listDocument[idx].isTransferring = true
          this.$axios.post(postUrl, payload).then(response => {
            if(response.status == 200){
              this.details.listDocument[idx].repositoryId = response.data.data
              this.details.listDocument[idx].extensionFile = fileExt
              this.$helper.toastSuccess(this, "Upload Dokumen Berhasil!")
            }
            else{
              this.$helper.toastError(this, "Upload Dokumen Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
            }
          })
          .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Upload Dokumen Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Upload Dokumen Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
          })
          .finally(() => {
            this.details.listDocument[idx].isTransferring = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },
    downloadDocument(idx) {
      let payload = new FormData()
      let postUrl = '/contractDocument/download/byte'
      payload.append("repositoryId", this.details.listDocument[idx].repositoryId)
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['Notaris'])){
        this.details.listDocument[idx].isTransferring = true
        this.$axios.post(postUrl, payload, {
          // necessary to avoid encoding returned bytes
          responseType: 'blob'
        }).then(response => {
          if(response.status == 200){
            // create file Blob and download according to extension
            let blob=new Blob([response.data], {type: "application/octet-stream"})
            let link=document.createElement('a')
            link.href=window.URL.createObjectURL(blob)
            link.download= this.details.listDocument[idx].repositoryId + "." + this.details.listDocument[idx].extensionFile
            link.click();
          }
          else{
            this.$helper.toastError(this, "Download Dokumen Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Download Dokumen Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Download Dokumen Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.details.listDocument[idx].isTransferring = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    }
  },

  computed:{
    showRemoveButton(){
      if (this.updateApprovalModalData.table.items.length > 1) {
        return true
      } else{
        return false
      }
    }
  },

  mounted(){
    this.getAPHT()
  }
}
</script>

<style scoped>
.btn.custom-button-disabled:disabled{
  cursor: default !important;
}
</style>
